import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';

import { getCurrentCourse } from 'redux/selectors/course';

import EditModeCenterButton from 'lecture_pages/components/edit-menu/actions/edit-mode-center-button';
import ExitButton from 'lecture_pages/components/edit-menu/actions/exit-button';
import { institutionBrandBorderWidth } from 'styles/global_defaults/scaffolding';

const styles = css`
  position: absolute;
  width: 100%;
  height: 60px;
  top: -${institutionBrandBorderWidth}px;
  left: 0px;
  z-index: 1;

  .close-edit-mode-button {
    position: absolute;
    right: 0;
  }
`;

const EditModeTopPanel = () => {
  const { $state } = useContext(AngularServicesContext);
  const { catalogId, isProgram } = useSelector(getCurrentCourse);

  const exitToPreviousMode = () => {
    $state.go(isProgram ? 'program-home' : 'course-home', { catalogId });
  };

  return (
    <div css={styles} className='d-flex align-items-center justify-content-center bg-black'>
      <div className='edit-mode-buttons align-items-center'>
        <EditModeCenterButton exitToPreviousMode={exitToPreviousMode} />
      </div>
      <div className='close-edit-mode-button'>
        <ExitButton onClick={() => exitToPreviousMode()} />
      </div>
    </div>
  );
};

export default EditModeTopPanel;
